import { createFileRoute, notFound } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { allHelpPages } from 'content-collections';

const fetchHelpPage = createServerFn({ method: 'GET' })
  .validator(z.string())
  .handler(async ({ data: path }) => {
    const helpPage = allHelpPages.find((item) => item.path === path);

    if (!helpPage) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    return {
      title: helpPage.title,
      filePath: helpPage.filePath,
    };
  });

export const Route = createFileRoute('/verwaltung/hilfe/$')({
  loader: async ({ params }) => {
    // eslint-disable-next-line no-underscore-dangle
    const splat = params._splat ?? '';

    if (!splat) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    return fetchHelpPage({ data: splat });
  },

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { filePath } = Route.useLoaderData();

  // Re-add the file extension here for Vite to know which files will be dynamically imported
  // https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
  const LazyContent = lazy(async () => {
    const parts = filePath.replace('.mdx', '').split('/');

    if (parts.length === 1 && parts[0]) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return import(`./../../../content/help/${parts[0]}.mdx`);
    }

    if (parts.length === 2 && parts[0] && parts[1]) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return import(`./../../../content/help/${parts[0]}/${parts[1]}.mdx`);
    }

    throw new Error('Unsupported depth of dynamic import');
  });

  return (
    <Suspense>
      <LazyContent />
    </Suspense>
  );
}
